<template>
    <div class="ds-ex-response">
        <ExchangeAvatar :person="response.user" />
        <div class="ds-ex-response-main">
            <div class="ds-ex-strong ds-ex-ellipsis">{{ fullName(response.user) || 'Сотрудник' }}</div>
            <div class="ds-ex-muted ds-ex-ellipsis">{{ subtitle }}</div>
        </div>
        <span v-if="response.source" class="ds-ex-chip" :class="`is-${SOURCE_TONES[response.source]}`">{{ SOURCE_LABELS[response.source] }}</span>
        <span class="ds-ex-response-time">{{ timeText }}</span>
        <template v-if="canDecide">
            <button type="button" class="ds-glass-btn ds-glass-btn-secondary" :disabled="busy" @click="emit('reject')">Отклонить</button>
            <button type="button" class="ds-glass-btn ds-glass-btn-primary" :disabled="busy" @click="emit('confirm')">Назначить</button>
        </template>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ExchangeAvatar from './ExchangeAvatar.vue'
import { fullName, SOURCE_LABELS, SOURCE_TONES, toLocal } from './exchangeFormat'
import type { VacancyResponseItem } from './exchangeTypes'

const props = defineProps<{ response: VacancyResponseItem, canDecide: boolean, busy: boolean }>()
const emit = defineEmits<{ confirm: [], reject: [] }>()

// Пустые nullable поля кандидата не ломают строку.
const subtitle = computed(() => [props.response.user.position?.name, props.response.user.department?.name].filter(Boolean).join(' · '))
const timeText = computed(() => props.response.createdAt ? `отклик в ${toLocal(props.response.createdAt).format('HH:mm')}` : '')
</script>
